import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { EYesNo } from '../../../../../shared/models/types.enum';

@Component({
  selector: 'description',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    ReactiveFormsModule
  ],
  templateUrl: './description.component.html',
  styleUrl: './description.component.css'
})
export class DescriptionComponent implements OnInit, OnChanges {

  @Input() witnessInterviewData: any = {};
  @Output() onSaveSection3 = new EventEmitter<any>();

  yesNo = EYesNo;
  descriptionForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "Describe exactly what happened including details such as time, place, or other people present. *",
      formControlName: "incident_details",
    },
    {
      question: "What exactly did the student who made or posed the threat say and/or do? Please be specific. *",
      formControlName: "student_actions",
    }
  ]

  constructor(
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['witnessInterviewData'] && this.witnessInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.witnessInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.descriptionForm = new FormGroup(group);
  }

  saveDescription(): void {
    if (this.descriptionForm.valid) {
      this.onSaveSection3.emit(this.descriptionForm.value);
    }
  }

}
